"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionTypes = void 0;
var actionTypes = {
  SUCCESS: "@@report-data-export/success",
  ERROR: "@@report-data-export/error",
  FUND_EXPORT_DOWNLOAD: "@@report-data-export/fund-export-download",
  FUND_TYPE_EXPORT_DOWNLOAD: "@@report-data-export/fund-type-export-download",
  FUND_TYPE_EXPORT_DOWNLOAD_RESET: "@@report-data-export/fund-type-export-download-reset",
  FUND_PERFORMANCE_EXPORT: "@@report-data-export/fund-performance-export",
  FUND_DONOR_EXPORT: "@@report-data-export/fund-donor-export",
  FUND_IMPACT_EXPORT: "@@report-data-export/fund-impact-export",
  IMPACT_TYPE_EXPORT: "@@report-data-export/impact-type-export",
  RESET: "@@report-data-export/reset",
  FUND_DISTRIBUTION_LIST: "@@report-data-export/fund-distribution-list",
  PRINT_BRIDGE_EXPORT: "@@print-bridge-export/print-bridge/report"
};
exports.actionTypes = actionTypes;